<template lang="pug">
#home
  alert-popup(:q="1")
  news-ticker(
    :messageList="messageList",
    v-if="messageList && messageList.length > 0"
  )
  .margin_top(v-if="messageList && messageList.length > 0")
  services(:homeData="homeData")
  slider-banner(:bannerList="homeData.area01_BannerList")
  slider-solutions(:homeData="homeData")
  customer(
    :image="homeData.area03_Image",
    :title="homeData.area03_Title",
    :locationNumber="homeData.area03_LocationNumber"
    :area03_PartnerItems="homeData.area03_PartnerItems"
  )
  //- media-img.golden_line_up(:imgUrl="'golden_line_up'")
  //- section.container
  //-   h2.i_h2_title.text-center.i_mt_10.i_mb_2 聚焦問題 解答疑惑
  //-   p.i_body_l.text-center 也歡迎至「
  //-     span
  //-       router-link(
  //-         tag="a",
  //-         :to="{ name: 'CustomerServiceContactUs' }",
  //-         style="cursor: pointer; color: #00a69c"
  //-       ) 聯絡我們
  //-     | 」留下問題，將有專人主動聯繫回覆您
  //-   .row
  //-     .col-6.col-md-3.i_mt_8.i_mt_md_4(
  //-       v-for="(question, index) in questions",
  //-       :key="index",
  //-       v-if="getFAQAmount(index)"
  //-     )
  //-       question(:question="question")
  //-   .row.text-center
  //-     router-link.i_mtb_10.see_more_btn.sm.btn_green(
  //-       tag="a",
  //-       :to="{ name: 'CustomerServiceFAQ' }"
  //-     ) 看更多
  media-img.golden_line_up(:imgUrl="'golden_line_up'")
  news
  thank-you-card.i_mt_8(:homeData="homeData")
  custom-footer
</template>
  
  <script>
  import CustomFooter from "@/components/common/Footer";
  import Services from "@/components/home/Services";
  import SliderBanner from "@/components/home/SliderBanner";
  import SliderSolutions from "@/components/home/SliderSolutions";
  import Customer from "@/components/home/Customer";
  import MediaImg from "@/components/common/MediaImg";
  import Question from "@/components/common/Question";
  import ThankYouCard from "@/components/home/ThankYouCard";
  import News from "@/components/home/News";
  import { getHomeIndex } from "@/json/home";
  import { getFAQDetail } from "@/json/FAQ";
  import { getMarquee } from "@/api/marquee";
  import AlertPopup from "@/components/common/AlertPopup";
  import NewsTicker from "@/components/common/NewsTicker";
  
  export default {
    name: "Home",
    metaInfo() {
      return {
        title: this.homeData.SEO_Title,
        meta: [{ name: "description", content: this.homeData.SEO_Description }],
      };
    },
    components: {
      "media-img": MediaImg,
      "custom-footer": CustomFooter,
      services: Services,
      "slider-banner": SliderBanner,
      "slider-solutions": SliderSolutions,
      customer: Customer,
      question: Question,
      news: News,
      NewsTicker,
      AlertPopup,
      ThankYouCard,
    },
    data() {
      return {
        homeData: {},
        FAQDetail: [],
        questions: [],
        FAQ1Detail: {},
        FAQ2Detail: {},
        FAQ3Detail: {},
        FAQ4Detail: {},
        messageList: [],
      };
    },
    created() {
      this.getHomeIndex();
      this.getMarquee();
    },
    methods: {
      onPopupOpen() {
        this.alertShowing = true
      },
      onPopupClose() {
        this.alertShowing = false
      },
      getFAQAmount(index) {
        if (this.$store.state.screenWidth > 767 && index < 4) {
          return true;
        } else if (this.$store.state.screenWidth < 768 && index < 2) {
          return true;
        } else {
          return false;
        }
      },
      getHomeIndex() {
        getHomeIndex().then((response) => {
          this.homeData = response.data;
          this.FAQDetail = [];
          getFAQDetail().then((response) => {
            this.FAQDetail = response.data.FAQDeatilList;
            for (let index in this.FAQDetail) {
              let tempFAQ = this.FAQDetail[index];
              if (this.homeData.area04_FAQ01ID == tempFAQ.FAQID) {
                this.FAQ1Detail = tempFAQ;
              }
              if (this.homeData.area04_FAQ02ID == tempFAQ.FAQID) {
                this.FAQ2Detail = tempFAQ;
              }
              if (this.homeData.area04_FAQ03ID == tempFAQ.FAQID) {
                this.FAQ3Detail = tempFAQ;
              }
              if (this.homeData.area04_FAQ04ID == tempFAQ.FAQID) {
                this.FAQ4Detail = tempFAQ;
              }
            }
            this.questions.push(this.FAQ1Detail);
            this.questions.push(this.FAQ2Detail);
            this.questions.push(this.FAQ3Detail);
            this.questions.push(this.FAQ4Detail);
          });
        });
      },
      getMarquee() {
        getMarquee()
          .then((response) => {
            if (response.data.Status) {
              this.messageList = response.data.Result;
            } else {
              this.messageList = [];
            }
          })
          .catch(() => {
            this.messageList = [];
          });
      },
    },
  };
  </script>
  
  <style lang="scss" scoped>
  @import "@/assets/style/home/home";
  </style>  